import { 
  Stack, Paper, Typography, CardMedia, 
  Box
} from '@mui/material';
import { useEffect, useState } from 'react';
import PRF_MEMBER_1 from '../../static/stock/prf-member-icon-1-black.png';
import PRF_MEMBER_2 from '../../static/stock/prf-member-icon-2-black.png';
import PRF_MEMBER_3 from '../../static/stock/prf-member-icon-3-black.png';

const PDFSupportAmount = 20;

export function MemberTransactionsInfo(props) {
  const [record, setRecord] = useState(null);
  const [showMember, setShowMember] = useState(false);
  const [showFullInfo, setShowFullInfo] = useState(false);

  useEffect(() => {
    if (props?.data) {
      parseData(props?.data);
    }
  },[props]);

  useEffect(() => {
    setShowMember(true);
    setShowFullInfo(record?.memberid_flag);
  },[record]);

  const parseData = (data) => {
    let t = data.transactions;
    if (t && t.length > 0) {
      data.earliest = t.reduce((a, b) => (a.valid_thru < b.valid_thru ? a : b));
      data.latest = t.reduce((a, b) => (a.valid_thru > b.valid_thru ? a : b));
      data.months = t.length;
      data.total = t.reduce((a, v) => a = a + v.ofp_usd_est,0).toFixed(2);
      data.pdf = Math.ceil(data.total / PDFSupportAmount);  
    }
    setRecord(data);
  }

  const SupportInfo = () => {
    if (!record || !record?.transactions) {
      return (<></>);
    }
    return (
      <Paper
        sx={{
          height: '100%',          
          // borderRadius: '1.5rem',
          // backgroundColor: '#000',
          color: '#000',
          textAlign: 'start',
          justifyItems: 'flex-start',
          alignItems: 'flex-start',
          alignContent: 'flex-start',
          borderBottomLeftRadius: '1.5rem',
              borderBottomRightRadius: '1.5rem',
        }}
        key={record.member_id+'supportinfo'}
      >
        <Stack sx={{ 
          // width: '100%', 
          p:2,
         }} spacing={4}>
          <Stack direction={'row'} spacing={3}>
            <Box sx={{
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center' ,
                backgroundColor: '#E2E8F0',
                borderRadius: '50%',
                p: 2
              }}>
              <CardMedia 
              sx={{ 
                width:'auto',  
                height: {
                  sm: '3rem',
                  xs: '2rem'
                },
                objectFit: 'contain' 
              }}  component='img' image={PRF_MEMBER_3}></CardMedia>
            </Box>
            <Stack spacing={1}>
              <Typography sx={{ 
                  fontSize: {
                    sm: '105%',
                    xs: '85%'
                  }
                }}>
                စုစုပေါင်းထောက်ပို့ခဲ့သည့်လ
              </Typography>
              <Typography 
                sx={{ 
                  color: '#000',
                  typography: { 
                    sm: 'h5',
                    xs: 'h6' 
                  },              
                  fontWeight: 'bold !important'     
                }}>
                {record.months} လ
              </Typography>
            </Stack>
          </Stack>
          <Stack direction={'row'} spacing={3}>
            <Box sx={{
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center' ,
                backgroundColor: '#E2E8F0',
                borderRadius: '50%',
                p: 2
              }}>
              <CardMedia 
                sx={{ 
                  width:'auto',  
                  height: {
                    sm: '3rem',
                    xs: '2rem'
                  },
                  objectFit: 'contain' 
                }}  component='img' image={PRF_MEMBER_2}></CardMedia>
            </Box>
            <Stack spacing={1}>
              <Stack>
                <Typography sx={{ 
                  fontSize: {
                    sm: '105%',
                    xs: '85%'
                  }
                }}>
                  ထောက်ပို့ခဲ့သည့်လအတွင်း စုစုပေါင်းထောက်ပို့နိုင်ခဲ့သည့် PDF ရဲဘော်
                </Typography>                
              </Stack>
              <Typography 
                sx={{ 
                  color: '#000',
                  typography: { 
                    sm: 'h5',
                    xs: 'h6' 
                  },    
                  fontWeight: 'bold !important'             
                }}>
                {record.pdf} ဦး
              </Typography>
            </Stack>
          </Stack>
          <Stack direction={'row'} spacing={3}>
            <Box sx={{
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center' ,
                backgroundColor: '#E2E8F0',
                borderRadius: '50%',
                p: 2
              }}>
            <CardMedia 
              sx={{ 
                width:'auto',   
                  height: {
                    sm: '3rem',
                    xs: '2rem'
                  },
                color: '#000',
                objectFit: 'contain' 
              }} component='img' image={PRF_MEMBER_1}></CardMedia>
            </Box>
            <Stack spacing={1}>
              <Stack>
                <Typography sx={{ 
                  fontSize: {
                    sm: '105%',
                    xs: '85%'
                  }
                }}>
                  ထောက်ပို့ခဲ့သည့်လအတွင်း စုစုပေါင်းထောက်ပို့နိုင်ခဲ့သည့် 
                  ငွေအမောင့်
                </Typography>                
              </Stack>              
              <Typography 
                sx={{ 
                  color: '#000',
                  typography: { 
                    sm: 'h5',
                    xs: 'h6' 
                  },                     
                  fontWeight: 'bold !important'                
                }}>
                EUSD {record.total}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Paper>
    );
  };

  return (
    <div>
      {showMember && showFullInfo && 
          <SupportInfo />
      }
    </div>
  );
}
